// 9fbef606107a605d69c0edbcd8029e5d
import { ADYEN_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const ADYENPAYMENT_CONSTANTS = {
  START_ADYEN_PAYMENT: `${ADYEN_ACTION_PATTERN}START_ADYEN_PAYMENT`,
  SET_ADYEN_SESSION_DATA: `${ADYEN_ACTION_PATTERN}SET_ADYEN_SESSION_DATA`,
  SET_ADYEN_SETUP_DATA: `${ADYEN_ACTION_PATTERN}SET_ADYEN_SETUP_DATA`,
  CREATE_ADYEN_SESSION: `${ADYEN_ACTION_PATTERN}CREATE_ADYEN_SESSION`,
  ADYEN_SESSION_CACHE_TTL: 30 * 60 * 1000,
};

export default ADYENPAYMENT_CONSTANTS;
